import firebase from "firebase"

const firebaseConfig = {
  apiKey: "AIzaSyC6856rULOQ_ewsdYt2Mf8Nnqe4I9G6XtQ",
  authDomain: "portfolio-5b959.firebaseapp.com",
  databaseURL: "https://portfolio-5b959.firebaseio.com",
  projectId: "portfolio-5b959",
  storageBucket: "portfolio-5b959.appspot.com",
  messagingSenderId: "758726341936",
  appId: "1:758726341936:web:114d130a67d3d89eaa44f5",
  measurementId: "G-1LG2KLZ9YZ"
}

const fire = firebase.initializeApp(firebaseConfig)

export default fire
